import { useQuery } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { GQL_SCORM_MODULE } from '~/gql/scorm-modules/scorm-modules'
import PreviewHeader from '~/pages/scorm/components/PreviewHeader'
import PreviewNoTrackingNotice from '~/pages/scorm/components/PreviewNoTrackingNotice'
import ScoPicker from '~/pages/scorm/components/ScoPicker'
import ScormShell from './ScormShell'
import { useScoNavigation } from './use-sco-navigation'

/** Commit no-op : la prévisualisation ne persiste aucune progression. */
async function noopCommit() {}

/**
 * Player de prévisualisation (Admin/Formateur) : joue un module directement
 * depuis l'écran de gestion, sans session ni inscription ni tracking.
 */
function ScormModulePreview() {
  const { t } = useTranslation()
  const { moduleId } = useParams()

  const { data, loading } = useQuery(GQL_SCORM_MODULE, {
    variables: { id: moduleId ?? '' },
    skip: !moduleId,
    fetchPolicy: 'network-only',
  })
  const module = data?.scormModule
  // Les chapitres d'un paquet à plusieurs SCO (#160) : l'admin les vérifie tous,
  // sans écriture — chaque chapitre repart vierge.
  const chapters = useScoNavigation(module?.id, null)
  const playing = chapters.multi ? chapters.active : undefined

  return (
    <ScormShell
      key={playing?.identifier ?? 'module'}
      loading={loading || chapters.loading}
      module={module && { ...module, launchUrl: playing?.href ?? module.launchUrl }}
      initialData={null}
      onCommit={noopCommit}
      headerContent={<PreviewHeader title={module?.title} />}
      /* Plus de lien de retour ici : le cadre en rend un, à gauche, depuis
         `fallbackTo`. Deux fois le même bouton dans un bandeau fait douter
         qu'ils mènent au même endroit. */
      headerRight={(
        <>
          {playing && <ScoPicker scos={chapters.scos} active={playing.identifier} completed={chapters.completed} onSelect={chapters.select} />}
          <PreviewNoTrackingNotice />
        </>
      )}
      fallbackTo="/back-office/modules"
      fallbackLabel={t('scorm.preview.backToModules')}
      unavailableMessage={t('scorm.preview.unavailable')}
    />
  )
}

export default ScormModulePreview
